import React from 'react';
import { format, parseISO } from 'date-fns';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer
} from 'recharts';

const ConsumptionChart = ({ data, selectedRange, customRange ,prepareChartData,chartConfig,height}) => {
  
  const CustomTooltip = ({ active, payload, label }) => {
    if (!active || !payload || !payload.length || 
        !payload.some(p => p.value > 0)) {
      return null;
    }

    return (
      <div style={{ 
        backgroundColor: '#fff',
        border: '1px solid #ccc',
        borderRadius: '4px',
        padding: '8px',
        zIndex: 9999,
        position: 'relative',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
      }}>
        <div style={{ marginBottom: '4px', fontSize: '11px', color: '#666' }}>
          {label}
        </div>
        {payload.map((entry, index) => (
          entry.value > 0 && (
            <div key={index} style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '4px' }}>
              <div style={{ 
                width: '12px', 
                height: '12px', 
                backgroundColor: entry.color,
                borderRadius: '2px'
              }} />
              <span>{entry.name}: {entry.value}</span>
            </div>
          )
        ))}
      </div>
    );
  };


  const chartData = prepareChartData();

  return (
    
    <ResponsiveContainer width="100%" height={height} >
      <BarChart
        data={chartData}
        margin={{
          top: 30,  // Reduced top margin
          right: 0,
          bottom: 0, // Removed bottom margin
          left: 2
        }}
        barCategoryGap="5%"
        barGap={2}
        
      >

        {/* //for title
        {title && (
          <text
          x={0}
          y={15}
          textAnchor="start"
          style={{
            fontSize: '12px',
            fill: '#333',
            fontWeight: 'bold'
          }}
          >
          {title}
          </text>
        )} */}
        
        <CartesianGrid 
          strokeDasharray="0 0"  // Makes lines solid instead of dotted
          horizontal={true}      // Show horizontal lines
          vertical={false}       // Hide vertical lines
        />
        <XAxis 
          dataKey="date"
          angle={0}
          height={60}
          interval={0}
          axisLine={false}  // Removes the axis line
          tickLine={false}
          tick={{ 
            fontSize: 9
          }}
          tickFormatter={(value) => {
            const firstDate = chartData[0] && chartData[0].date;
            const lastDate = chartData[chartData.length - 1] && chartData[chartData.length - 1].date;
            const dateObj = typeof value === 'string' ? parseISO(value) : new Date(value);
            if (value === firstDate || value === lastDate) {
            return format(dateObj, 'MMM d');
            }
            return "";
          }}
        />
       <YAxis 
          axisLine={false}  // Removes the axis line
          tickLine={false}  // Removes the tick lines
          tick={{ 
            fontSize: 9,    // Matches your XAxis font size
            fill: '#666'    // Sets the label color
          }}
        />
        <Tooltip 
          cursor={false}
          content={<CustomTooltip />}
          //content={<CustomTooltip title={title}  />}
          // contentStyle={{
          //   backgroundColor: '#fff',
          //   border: '1px solid #ccc',
          //   borderRadius: '4px',
          //   padding: '8px'
          // }}
        />
        {/* <Legend /> */}
        {chartConfig.map((config) => (
        <Bar
          key={config.dataKey}
          dataKey={config.dataKey}
          name={config.name}
          stackId="a"
          fill={config.fill}
          barSize={20}
        />
      ))}
        {/* <Bar 
          dataKey="PlaybookCreated"
          name={"Playbook Created"}
          stackId="a"
          fill="#ec3a3a"
          barSize={30}
        />
        <Bar 
          dataKey="PlaybookGenerated"
          name={"Playbook Generated"}
          stackId="a"
          fill="#2599F7"
          barSize={30}
        />
        <Bar 
          dataKey="PlaybookPublished"
          name={"Playbook Published"}
          stackId="a"
          fill="#797bfc"
          barSize={30}
        />
        <Bar 
          dataKey="Activities"
          name={"Activities Generated"}
          stackId="a"
          fill="#8884d8" 
          barSize={30}
        />
        <Bar 
          dataKey="Links"
          name={"Links Researched"}
          stackId="a"
          fill="#82ca9d" 
          barSize={30}
        />
        <Bar 
          dataKey="Exports"
          name={"Playbooks Exported"}
          stackId="a"
          fill="#ffc658" 
          barSize={30}
        />
        <Bar 
          dataKey="Initiatives"
          name={"Initiatives Created"}
          stackId="a"
          fill="#eb7bf9" 
          barSize={30}
        />
        <Bar 
          dataKey="Teams"
          name={"Teams Created"}
          stackId="a"
          fill="#d35400" 
          barSize={30}
        /> */}

        {/* <Bar 
          dataKey="InvitesCreated"
          name={"Invites Sent"}
          stackId="a"
          fill="#DE3163" 
          barSize={30}
        /> */}

        {/* <Bar 
          dataKey="InvitesUpdated"
          name={"Invites Updated"}
          stackId="a"
          fill="#7f0000" 
          barSize={30}
        /> */}

      </BarChart>
    </ResponsiveContainer>
  );
};

export default ConsumptionChart;